export default {"src":"/_next/static/media/QUANT.722c39e1.svg","height":52,"width":48,"blurWidth":0,"blurHeight":0};